'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Label = styled__default.default.label `
  display: block;
  background: ${({ theme }) => theme.designTokens.formLabelBackgroundColor};
  color: ${({ theme }) => theme.designTokens.formLabelTextColor};
  font-family: ${({ theme }) => theme.designTokens.formLabelFontFamily};
  font-size: ${({ theme }) => theme.designTokens.formLabelFontSize};
  font-weight: ${({ theme }) => theme.designTokens.formLabelFontWeight};
  letter-spacing: ${({ theme }) => theme.designTokens.formLabelLetterSpacing};
  line-height: ${({ theme }) => theme.designTokens.formLabelLineHeight};
`;
const Required = styled__default.default.span `
  font: inherit;
  display: inline-block;
  color: ${({ theme }) => theme.designTokens.formLabelRequiredIndicatorColor};
`;
const Styled = {
    Label,
    Required,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
